import { createSlice } from "@reduxjs/toolkit";
import { Dispatch } from "redux";
import axios from "../utils/axios.tsx";
import type { FeatureFlagsState } from "./types.tsx";

const initialState: FeatureFlagsState = {
  flags: [],
  loading: false,
  error: null,
};

const featureFlagsSlice = createSlice({
  name: "featureFlags",
  initialState,
  reducers: {
    setFeatureFlags(state, action) {
      state.flags = action.payload;
      state.loading = false;
      state.error = null;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const featureFlagsActions = featureFlagsSlice.actions;

export const fetchFeatureFlags = () => {
  return async (dispatch: Dispatch) => {
    dispatch(featureFlagsActions.setLoading(true));
    try {
      const response = await axios.get("/v1/feature_flag/", {
        withCredentials: true,
      });

      if (response.status === 200) {
        dispatch(featureFlagsActions.setFeatureFlags(response.data));
      } else {
        dispatch(featureFlagsActions.setError("Failed to fetch feature flags"));
      }
    } catch (error) {
      console.error("Error fetching feature flags:", error);
      dispatch(
        featureFlagsActions.setError(
          error instanceof Error ? error.message : "Unknown error",
        ),
      );
    }
  };
};

export default featureFlagsSlice.reducer;
